import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

/**
 * <img> wrapper that loads protected file via blob URL so we don't expose
 * the access token in the DOM. Falls back to plain auth query if no token.
 */
export default function AuthenticatedImage({ path, alt, className, onClick }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;
    setError(false);
    setSrc(null);
    if (!path) return undefined;

    (async () => {
      try {
        const resp = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(resp.data);
        setSrc(objectUrl);
      } catch (e) {
        if (!cancelled) setError(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (error) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-500 text-xs ${className || ""}`}>
        Error al cargar
      </div>
    );
  }
  if (!src) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-400 text-xs animate-pulse ${className || ""}`}>
        Cargando...
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt || "documento"}
      className={className}
      onClick={onClick}
      data-testid="authenticated-image"
    />
  );
}
